import { useDispatch, useSelector } from 'react-redux';
import '../../css/base.css';
import TheCottage from './theCottage';
import GettingThere from './gettingThere';
import ContactUs from './contactUs';
import Access from './access';
import Bedrooms from './bedrooms';
import Wifi from './wifi';
import Finally from './finally';
import Heating from './heating';
import Kitchen from './kitchen';
import Leaving from './leaving';
import LivingRoom from './livingRoom';
import Shopping from './shopping';
import Miscellaneous from './miscellaneous';
import Kayaks from './kayaks';
import Outdoors from './outdoors';
import Parking from './parking';
import Pets from './pets';
import ThingsToDo from './thingsToDo';
import arnisdale_small from '../../img/arnisdale_small.jpg';
import arnisdale_medium from '../../img/arnisdale_medium.jpg';
import arnisdale_large from '../../img/arnisdale_large.jpg';
import { setPage, setSection} from '../../store/AppSlice';

const YourStayCondensed = () => {

  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);

  const navigateToLocation = () => {
    dispatch(setPage("LOCATION"));
  }

  const navigateToContact = () => {
    dispatch(setPage("CONTACT"));
  }

  const isVIP = () => {
    if (appstate.vip === true) {
      return (
        <div id="your-stay-vip-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "VIP")}>
            Kayaks
        </div>
      )
    } 
  }

  const selectSection = (event, data) => {

    var allMenuItems = document.getElementsByClassName("left-menu-btn");

    Array.from(allMenuItems).forEach((item) => {
      item.style.backgroundColor = "#61a5c2";
      item.style.color = "white";
    });      

    var menu = document.getElementById(event.target.id);
    menu.style.backgroundColor = "#468faf";
    menu.style.color = "#325288";

    dispatch(setSection(data));
  }

  let sectionName = <TheCottage />;

  switch (appstate.section) {
    case "COTTAGE":
      sectionName =  <TheCottage />;
      break;
    case "GETTING_THERE":
      sectionName =  <GettingThere />;
      break;
    case "ACCESS":
      sectionName =  <Access />;
      break;
    case "ROOMS":
      sectionName =   <div>
                        <Bedrooms />
                        <LivingRoom />
                        <Kitchen />
                      </div>;
      break;
    case "HEATING":
      sectionName =  <Heating />;
      break;
    case "WIFI":
      sectionName =  <Wifi />;
      break;
    case "SHOPPING":
      sectionName =  <Shopping />;
      break;
    case "MISCELLANEOUS":
      sectionName =  <Miscellaneous />;
      break;
    case "VIP":
      sectionName =  <Kayaks />;
      break;
    case "OUTDOORS":
      sectionName =  <Outdoors />;
      break;
    case "PARKING":
      sectionName =  <Parking />;
      break;
    case "PETS":
      sectionName =  <Pets />;
      break;
    case "THINGS_TO_DO":
      sectionName =  <ThingsToDo />;
      break;
    case "PROBLEMS":
      sectionName =  <ContactUs />;
      break;
    case "LEAVING":
      sectionName =  <Leaving />;
      break;
    case "FINALLY":
      sectionName =  <Finally />;
      break;
    default:
      sectionName = <TheCottage />;
  }


  return (
    <div className="row imagesBackgroundColour your-stay-condensed">
      <div className="col-3 col-md-2 col-xl-1 left-menu-col">
        <div id="your-stay-cottage-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "COTTAGE")}>
            Cottage
        </div>
        <div id="your-stay-getting-there-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "GETTING_THERE")}>
            Location
        </div>
        <div id="your-stay-access-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "ACCESS")}>
            Access
        </div>
        <div id="your-stay-rooms-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "ROOMS")}>
            Rooms
        </div>
        <div id="your-stay-wifi-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "WIFI")}>
            Wifi
        </div>
        <div id="your-stay-heating-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "HEATING")}>
            Heating
        </div>
        <div id="your-stay-shopping-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "SHOPPING")}>
            Shopping
        </div>
        <div id="your-stay-outdoors-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "OUTDOORS")}>
            Outdoors
        </div>
        <div id="your-stay-parking-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "PARKING")}>
            Parking
        </div>
        <div id="your-stay-pets-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "PETS")}>
            Pets
        </div>
        <div id="your-stay-things-to-do-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "THINGS_TO_DO")}>
            Activities
        </div>
        {isVIP()}
        <div id="your-stay-miscellaneous-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "MISCELLANEOUS")}>
            Other
        </div>
        <div id="your-stay-problems-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "PROBLEMS")}>
            Contact
        </div>
        <div id="your-stay-leaving-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "LEAVING")}>
            Leaving
        </div>
        <div id="your-stay-finally-menu-item" className="left-menu-btn" onClick={(event) => selectSection(event, "FINALLY")}>
            Finally
        </div>
      </div>
      <div className="col-9 col-md-10 col-xl-11 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            {sectionName}
          </div>
        </div>
      </div>
      <div className="col-12 imagesBackgroundColour no-padding">
        <picture>
          <source srcSet={`${arnisdale_small} 1x,${arnisdale_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${arnisdale_medium} 1x,${arnisdale_large} 2x`}
            src={arnisdale_large} alt="Arnisdale Panorama" className="image"
          />
        </picture>
    </div>

    </div>
  );
}

export default YourStayCondensed
